<template>
    <div class="section-2">
        <!-- 视频 -->
        <vdr class-name="my-vdr" v-show="videoShow" 
            :w="vdrWidth" :h="vdrHeight" :minWidth="380" :minHeight="310" :x="vdrX" :y="vdrY">
            <div class="video-box" @mouseenter="handleHover" @mouseleave="handleLeave">
                <div class="video-title">
                    <span>{{videoData.title}}</span>
                    <a-icon type="close" class="close" @click="videoHide"/>
                </div>
                <video id="myVideoJs" class="video-js vjs-default-skin vjs-big-play-centered">
                    <source src="//img.library.sh.cn/hisdata/his/bg1/movie.m3u8" type="application/x-mpegURL" >
                </video>
            </div>
        </vdr>

        <div class="tab-box">
            <div class="tabs">
                <span :class="pageTab===1?'tab cur':'tab'" @click="()=>{this.pageTab=1}">
                    <img src="./img/tab1.png" alt="">
                    电影
                </span>
                <span :class="pageTab===2?'tab cur':'tab'" @click="()=>{this.pageTab=2}">
                    <img src="./img/tab2.png" alt="">
                    影人
                </span>
                <span :class="pageTab===3?'tab cur':'tab'" @click="()=>{this.pageTab=3}">
                    <img src="./img/tab3.png" alt="">
                    影戏院
                </span>
            </div>
            <div class="tab-content">
                <div class="tab-content1" v-show="pageTab===1">
                    <a href="javascript:" class="prev-tab1" @click="handleTab1Prev">
                        <a-icon type="left" style="font-size: 20px;"></a-icon>
                    </a>
                    <a href="javascript:" class="next-tab1" @click="handleTab1Next">
                        <a-icon type="right" style="font-size: 20px;"></a-icon>
                    </a>
                    <div class="swipe-box">
                        <swiper :options="swiperOptions">
                            <swiper-slide v-for="(item,index) in dataSource1" :key="index" class="basic-item">
                                <div class="info">
                                    <div class="name">{{item.filmName}}</div>
                                    <div class="des">{{item.filmDate+'年 '}}{{item.filmTime || ''}}</div>
                                </div>
                                <div class="content" @mouseenter="handleHover" @mouseleave="handleLeave">
                                    {{item.filmDescription.slice(0, 30)+'...'}}
                                </div>
                                <!-- <div class="cover" :data-selfuri="item.selfUri"
                                    :style="'width:254px;height:314px;background-size:100% 100%;background-image: url('+item.imgPath.replace( 'http://data.library.sh.cn/shmemory/resource/img/', 'https://img.library.sh.cn/dy/video/filmbill/' )+')'"></div> -->
                                <img :data-selfuri="item.selfUri" :src="item.imgPath.replace(
                                    'http://data.library.sh.cn/shmemory/resource/img/', '//img.library.sh.cn/dy/video/filmbill/'
                                )+'!254x314'" alt="">
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
                <div class="tab-content2" v-show="pageTab===2">
                    <!--  @click="handleTab2Prev" -->
                    <a href="javascript:" class="prev-tab2">
                        <a-icon type="left" style="font-size: 20px;"></a-icon>
                    </a>
                    <!--  @click="handleTab2Next" -->
                    <a href="javascript:" class="next-tab2">
                        <a-icon type="right" style="font-size: 20px;"></a-icon>
                    </a>
                    <div class="swipe-box">
                        <swiper :options="swiperOptions2" ref="personSwiper">
                            <swiper-slide v-for="(item,index) in dataSource2" :key="index" class="basic-item">
                                <!-- ./img/deomo.jpg -->
                                <img v-if="item.img" 
                                    :data-selfuri="item.uri" 
                                    :src="'//img.library.sh.cn/person/'+item.img" alt=""
                                >
                            </swiper-slide>
                        </swiper>
                        <div class="des" v-if="dataSource2[swiper2Index] && dataSource2[swiper2Index].nameChs">
                            {{dataSource2[swiper2Index].nameChs}}
                            {{dataSource2[swiper2Index].birthday || dataSource2[swiper2Index].deathday ? '(' : ''}}
                            {{dataSource2[swiper2Index].birthday || ''}}
                            {{dataSource2[swiper2Index].deathday ? '- '+dataSource2[swiper2Index].deathday : ''}}
                            {{dataSource2[swiper2Index].birthday || dataSource2[swiper2Index].deathday ? ')' : ''}}
                        </div>
                    </div>
                </div>
                <div class="tab-content3" v-show="pageTab===3">
                    <div class="map-box" id="openseadragon" @mouseenter="handleHover" @mouseleave="handleLeave">
                        <!-- <img src="./img/map.jpg" alt=""> -->
                    </div>
                </div>
            </div>
            <div class="bottom-pic-list">
                <div class="bottom-pic-list-pos">
                    <div class="item-cell" v-for="(item, index) in videoList" :key="'videoList'+index">
                        <img :src="item.videoPath.replace(
                            '/video/', '/video/firstimg/'
                        ).replace('.wmv', '.jpg')+'!205x100'" alt="">
                        <div class="hover-text">
                            <p>名称：{{item.title}}</p>
                            <p>主演：{{arrayToString(item.personList, 'pname', ' ')}}</p>
                            <p>类型：{{item.type}}</p>
                            <a href="javascript:;" @click="player(item)">
                                <a-icon type="play-circle" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    export default {
        components: {
            Swiper,
            SwiperSlide
        },
        directives: {
            swiper: directive
        },
        props: {
            screenIndex: {
                required: true
            },
            showContent: {
                required: true
            }
        },
        data() {
            return {
                swiperOptions: {
                    slidesPerView: 4,
                    spaceBetween: 5,
                    freeMode: false,
                    navigation: {
                        nextEl: '.next-tab1',
                        prevEl: '.prev-tab1',
                    },
                    loop: true,
                    on: {
                        click:(e)=>{
                            window.open("https://ldy.library.sh.cn/movie/movieDetail?uri="+e.target.dataset.selfuri)
                        }
                    },
                },
                swiperOptions2:{
                    slidesPerView: 5,
                    spaceBetween: 30,
                    centeredSlides: true,
                    loop: true,
                    navigation: {
                        nextEl: '.next-tab2',
                        prevEl: '.prev-tab2',
                    },
                    on: {
                        click:(e)=>{
                            window.open("https://ldy.library.sh.cn/person/personDetailAll?uri="+e.target.dataset.selfuri)
                        },
                        slideChange:(e)=>{
                            setTimeout(() => {
                                let _swiper = this.$refs.personSwiper.$swiper;
                                this.swiper2Index = _swiper.realIndex;
                                // console.log(_swiper);
                            }, 100);
                        }
                    },
                },
                swiper1Index:0,
                swiper2Index:0,
                dataSource1:[],
                dataSource2:[
                    { nameChs:'' },
                    { nameChs:'' }
                ],
                timer:null,
                pageTab:1,
                // 电影视频
                myPlayer: null,
                videoShow: false,
                videoList: [],
                videoData: {},
                vdrWidth: 540,
                vdrHeight: 430,
                vdrX: 0,
                vdrY: -360,
                // 地图展示
                viewer: null,
                // mapImage: require('./img/map2.jpg'),
                overlays: [
                    {
                        name:"大光明电影院", tIndex: 1, id:'overlays_link1', x:0.375, y:0.230, width:0.01, height:0.01,
                        className: "pos-icon", uri:"http://data.library.sh.cn/entity/theater/153c4cro10bqx5zw"
                    },
                    {
                        name:"兰心大戏院", tIndex: 2, id:'overlays_link2', x:0.284, y:0.266, width:0.03, height:0.03,
                        className: "pos-icon", uri:"http://data.library.sh.cn/entity/theater/g2n5f6cpkqkaxygj"
                    },
                    {
                        name:"国泰", tIndex: 3, id:'overlays_link3', x:0.28, y:0.289, width:0.03, height:0.03,
                        className: "pos-icon", uri:"javascript:"
                    },
                    {
                        name:"美琪大戏院", tIndex: 4, id:'overlays_link4', x:0.28,	y:0.202, width:0.03, height:0.03,
                        className: "pos-icon", uri:"http://data.library.sh.cn/entity/theater/faxjacqku1ktugml"
                    },
                    {
                        name:"上海音乐厅", tIndex: 5, id:'overlays_link5', x:0.394, y:0.261, width:0.03, height:0.03,
                        className: "pos-icon", uri:"http://data.library.sh.cn/entity/theater/86ac5nfcwmcff6pj"
                    },
                    {
                        name:"上海大戏院", tIndex: 6, id:'overlays_link6', x:0.261, y:0.313, width:0.03, height:0.03,
                        className: "pos-icon", uri:"http://data.library.sh.cn/entity/theater/qx1jqmome3n3jmx4"
                    },
                    {
                        name:"新光影艺苑", tIndex: 7, id:'overlays_link7', x:0.409, y:0.206, width:0.02, height:0.02,
                        className: "pos-icon", uri:"http://data.library.sh.cn/entity/theater/en35d3v0eud14egz"
                    },
                    {
                        name:"黄浦剧场", tIndex: 8, id:'overlays_link8', x:0.42, y:0.2, width:0.02,	height:0.02,
                        className: "pos-icon", uri:"http://data.library.sh.cn/entity/theater/ndyxyk107xfx2ulp"
                    },
                    {
                        name:"人民大舞台", tIndex: 9, id:'overlays_link9', x:0.415, y:0.23, width:0.02, height:0.02,
                        className: "pos-icon", uri:"http://data.library.sh.cn/entity/theater/2ti54blfkeh3tik1"
                    },
                    {
                        name:"长江剧场", tIndex: 10, id:'overlays_link10', x:0.380, y:0.224, width:0.01, height:0.01,
                        className: "pos-icon", uri:"http://data.library.sh.cn/entity/theater/qvuufej4mc48cjd5"
                    }
                ]
            }
        },
        mounted() {
            // window.onload = ()=>{
            this.$nextTick(()=>{
                // this.bottomAnimate()
                this.getHomeFilmBillList() // 电影海报
                this.getPersonImageList()  // 人物照片
                this.setOpenSeadragon();   // 影戏院
                this.getHomeVideoList()    // 视频轮播
                this.myPlayer = this.setVideoJsOptions('myVideoJs');
            })
            // }
        },
        methods: {
            getHomeFilmBillList(){ // 电影海报
                this.$axios.get(this.Common.getHomeFilmBillListUrl)
                .then((res) => {
                    let resultData = res.data;
                    this.dataSource1 = resultData.data;
                })
                .catch((err) => {
                    console.log(err)
                });
            },
            getPersonImageList(){ // 人物照片
                this.$axios.get(this.Common.getPersonImageListUrl)
                .then((res) => {
                    let resultData = res.data;
                    this.dataSource2 = resultData.data;
                })
                .catch((err) => {
                    console.log(err)
                });
            },
            getHomeVideoList(){ // 视频轮播
                this.$axios.get(this.Common.getHomeVideoListUrl)
                .then((res) => {
                    let resultData = res.data;
                    this.videoList = resultData.data;
                    // 底部视频轮播
                    setTimeout(() => {
                        this.bottomAnimate()
                    }, 100);
                })
                .catch((err) => {
                    console.log(err)
                });
            },
            player(item){ // 视频显示并播放
                if(!this.videoShow) {
                    this.vdrX = $(window).width() - this.vdrWidth;
                    this.vdrY = ($(window).height() - this.vdrHeight)/2;
                    this.videoShow = !this.videoShow;
                }
                this.myPlayer.pause();
                this.videoData = item;
                let videoUri   = item.videoPath.replace('.wmv', '/movie.m3u8');
                this.myPlayer.src(videoUri); 
                // this.myPlayer.load(videoUri);
                this.myPlayer.play();
            },
            videoHide(){ // 关闭视频
                this.myPlayer.pause();
                this.videoShow = false;
            },
            setOpenSeadragon(){ // 地图展示
                //地图
                this.viewer = this.$Openseadragon({
                    id:"openseadragon",
                    prefixUrl: '//cdnjs.cloudflare.com/ajax/libs/openseadragon/2.4.2/images/', // require('openseadragon/images/')
                    visibilityRatio: 		 1,
                    minZoomLevel: 			 1,				//最小允许放大倍数
                    maxZoomLevel: 			 15,			//最大允许放大倍数
                    defaultZoomLevel:		 1,	            //默认放大倍数
                    showNavigationControl: 	 true,
                    showHomeControl: 		 true,			//显示home按钮
                    showFullPageControl: 	 true,			//显示全屏按钮
                    // navigationControlAnchor: "Full",		//TOP_LEFT
                    gestureSettingsMouse: {
                        clickToZoom: 	false,			//关闭单击鼠标放大
                        dblClickToZoom: true			//开启双击鼠标放大
                    },
                    tileSources: {
                        type: 'image',
                        url: require('./img/map2.jpg'),
                        crossOriginPolicy: 'Anonymous',
                        ajaxWithCredentials: false
                    },
                    //overlays是设置定位点
                    overlays: this.overlays
                });

                this.addOnceHandler();
                this.addHandler();
            },
            androidOrIOS() { // 判断是Android还是IOS
                let u = navigator.userAgent, app = navigator.appVersion;
                //是否为安卓
                let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                //是否为IOS
                let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                let system = isAndroid ? 'isAndroid' : (isIOS ? 'isIOS' : null);
                return system;
            },
            titleMeg() { // 地图影院提示
                let _this = this;
                $(".openseadragon-canvas a").on("mouseover", function() {
                    //截取元素id最后的数字
                    let indexID = $(this).attr("id").substring(13);
                    //影戏院在数组中的下标
                    let index = parseInt(indexID) - 1;
                    $(this).attr("title", _this.overlays[index].name);
                });
            },
            index_tap_link(){ // 地图标记链接点击
                let _this = this;
                //判断是移动端还是PC端
                let system = _this.androidOrIOS();
                let event = system == null ? "click" : "touchstart";
                
                //影戏院地址链接
                let architectureLink = "https://ldy.library.sh.cn/architecture/architectureDetail?";
                //地图标记链接点击事件
                $(".openseadragon-canvas a").on(event, function() {
                    //截取元素id最后的数字
                    let indexID = $(this).attr("id").substring(13);
                    //影戏院在数组中的下标
                    let index = parseInt(indexID) - 1;
                    //获取影戏院uri
                    let uri = _this.overlays[index].uri;
                    if(uri.indexOf("http") == 0){
                        if(system == null){
                            window.open(architectureLink + "uri=" + uri);
                        } else {
                            window.location.href = architectureLink + "uri=" + uri;
                        }
                    }
                });
            },
            ele_hover_ts(ele, txt, _t) { // 提示信息框
                let t=_t||0;
                ele.on("mouseenter",function(){
                    $(".ele_hover_ts").remove();
                    $("body").append("<div class='ele_hover_ts' style='position:fixed;max-width:340px;height:auto;color:#fff;z-index:9999;background:rgba(0,0,0,1);border-radius:4px;padding:5px 10px;line-height:20px;'><span></span><i style='position:absolute;top:50%;right:-4px;margin-top:-8px;border-left:8px solid #000;border-top:8px solid transparent;border-bottom: 8px solid transparent;'></i></div>");
                    let _t=$(this);
                    setTimeout(function(){
                        $(".ele_hover_ts").find("span").text(txt)
                        $(".ele_hover_ts").css({
                            "top":parseInt(_t.offset().top)-parseInt($(document).scrollTop())+t,
                            "left":parseInt(_t.offset().left)-parseInt($(document).scrollLeft())-parseInt(20+parseInt($(".ele_hover_ts").width()))
                        })
                    },10)
                })
                ele.on("mouseleave",function(){
                    $(".ele_hover_ts").hide();
                })
            },
            addOnceHandler(){
                let _this = this;
                _this.viewer.addOnceHandler('open', function() {
                    /* touch.on(".openseadragon-canvas a","touchstart",function(e){
                        e.stopPropagation()
                    }) */
                    
                    // 地图标识提示 PC端提示信息
                    for(let j=0; j<$(".openseadragon-canvas a").length; j++){
                        _this.ele_hover_ts($("#overlays_link"+(j+1)), _this.overlays[j].name);
                    }
                    
                    //地图标记点击事件
                    _this.index_tap_link();
                    //地图影院title提示
                    //titleMeg();
                }, null, 1);
            },
            addHandler(){
                let _this = this;
                _this.viewer.addHandler('full-screen', function(e){ // 全屏/退出全屏时
                    if(!e.fullScreen){ // 退出全屏时
                        _this.$emit('exitFullScreen', e.fullScreen);
                    }
                });
            },
            handleHover(){
                this.$emit('fullpageStop', false);
            },
            handleLeave(){
                this.$emit('fullpageStart', true);
            },
            handleTab1Prev(){
                if(this.swiper1Index===0){
                    this.swiper1Index = this.dataSource1.length-1
                }else{
                    this.swiper1Index--
                }
            },
            handleTab1Next(){
                if(this.swiper1Index===this.dataSource1.length-1){
                    this.swiper1Index = 0
                }else{
                    this.swiper1Index++
                }
            },
            handleTab2Prev(){
                if(this.swiper2Index===0){
                    this.swiper2Index = this.dataSource2.length-1
                }else{
                    this.swiper2Index--
                }
            },
            handleTab2Next(){
                if(this.swiper2Index===this.dataSource2.length-1){
                    this.swiper2Index = 0
                }else{
                    this.swiper2Index++
                }
            },
            bottomAnimate(){
                const ele = document.getElementsByClassName('bottom-pic-list-pos')[0]
                const w = ele.offsetWidth - document.body.clientWidth
                let off = 0
                let d = 1
                clearInterval(this.timer)
                if(w<0){
                    return
                }
                this.timer = setInterval(()=>{
                    if(off === w){
                        d = -1
                    }
                    if(off === 0){
                        d = 1
                    }
                    off = off + d
                    ele.style.transform = `translate(${-off}px,0)`
                },50)
            },
            setVideoJsOptions(videoEle){
                const _this  = this;
                // let _video   = document.getElementById(videoEle);
                // 初始化视频方法
                let _videoJs = this.$VideoJs(videoEle, {
                    techOrder: ['html5', 'flash'],
                    language: 'zh-CN',
                    // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                    controls: true,
                    // 自动播放属性, muted:静音播放
                    // autoplay: "muted",
                    // 视频封面
                    // poster: this.videoList[this.current].poster,
                    // 建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                    preload: "auto",  // "auto"
                    // 设置视频播放器的显示宽度（以像素为单位）
                    width: "100%",
                    // 设置视频播放器的显示高度（以像素为单位）
                    // height: "100%",
                    loop: false, // 是否循环播放
                    bigPlayButton: false,
                    textTrackDisplay: false,
                    posterImage: false, // true
                    errorDisplay: false,
                    playbackRates: [0.25, 0.5, 1, 1.5, 2, 4, 8, 16], //播放倍数
                    hls: {
                        withCredentials: false
                    },
                    // hls: true,  //启用hls？
                    // flash: {
                    //     //swf: '/videojs/video-js.swf'
                    //     //放在static或着public下面文件夹中的videojs文件夹中 当引入js文件中统一定义时此处可省略
                    //     hls: { withCredentials: false },
                    // },
                    // html5: { hls: { withCredentials: false } },
                    // 配置控制栏
                    // controlBar: false,
                    // controlBar: {
                    //     volumePanel: {
                    //             inline: false,          // 音量调节是否水平
                    //     },
                    //     timeDivider: true,              // 时间分割线
                    //     currentTimeDisplay:true,        // 当前播放位置
                    //     durationDisplay: true,          // 总时间
                    //     progressControl: true,          // 进度条
                    //     remainingTimeDisplay: false,    // 剩余时间
                    //     fullscreenToggle: true          // 全屏按钮
                    // }
                }, function() {
                    this.on("loadstart",function(){
                        // console.log("开始请求数据 ");
                    })
                    this.on('progress', function () {
                        // console.log('正在请求数据')
                    })
                    this.on("play", function(){
                        // console.log("视频开始播放")
                    })
                    this.on("ended", function () {
                        // console.log('视频'+_this.index+'播放结束了');
                    })
                    this.on("error", function () {
                        console.log("异常，无法播放")
                    })
                })

                return _videoJs;
            }
        }
    }
</script>

<style lang="less" scoped>
    /deep/ .swiper-slide {
        width: auto;
    }
    // 电影视频
    .my-vdr{
        position: fixed;
        z-index: 99!important;
        .video-box {
            height: 100%;
            .video-title{
                position: fixed;
                // background: #fff;
                width: 100%;
                height: 30px;
                line-height: 30px;
                color: #fff;
                // top: -30px;
                z-index: 99999;
                span{
                    margin-left: 5px;
                }
                .close{
                    float: right;
                    line-height: 20px;
                    padding: 5px;
                    cursor: pointer;
                }
            }
            .myVideoJs-dimensions {
                width: 100%!important;
                height: 100%!important;
            }
            .video-js {
                width: 100%!important;
                height: 100%!important;
                z-index: 999!important;
            }
        }
    }

    // 地图标识动画
    @keyframes icon_animate {
        0% {
            transform: scale(1);
            -ms-transform: scale(1);
            -webkit-transform: scale(1);
            -o-transform: scale(1);
            -moz-transform: scale(1);
            opacity: 0.7;
        }
        50% {
            transform: scale(1.1);
            -ms-transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -o-transform: scale(1.1);
            -moz-transform: scale(1.1);
            opacity: 1;
        }
        100% {
            transform: scale(1);
            -ms-transform: scale(1);
            -webkit-transform: scale(1);
            -o-transform: scale(1);
            -moz-transform: scale(1);
            opacity: 0.7;
        }
        }
    @-moz-keyframes icon_animate {
        /* Firefox */
        0% {
            transform: scale(1);
            -ms-transform: scale(1);
            -webkit-transform: scale(1);
            -o-transform: scale(1);
            -moz-transform: scale(1);
            opacity: 0.7;
        }
        50% {
            transform: scale(1.1);
            -ms-transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -o-transform: scale(1.1);
            -moz-transform: scale(1.1);
            opacity: 1;
        }
        100% {
            transform: scale(1);
            -ms-transform: scale(1);
            -webkit-transform: scale(1);
            -o-transform: scale(1);
            -moz-transform: scale(1);
            opacity: 0.7;
        }
    }
    @-webkit-keyframes icon_animate {
        /* Safari �� Chrome */
        0% {
            transform: scale(1);
            -ms-transform: scale(1);
            -webkit-transform: scale(1);
            -o-transform: scale(1);
            -moz-transform: scale(1);
            opacity: 0.7;
        }
        50% {
            transform: scale(1.1);
            -ms-transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -o-transform: scale(1.1);
            -moz-transform: scale(1.1);
            opacity: 1;
        }
        100% {
            transform: scale(1);
            -ms-transform: scale(1);
            -webkit-transform: scale(1);
            -o-transform: scale(1);
            -moz-transform: scale(1);
            opacity: 0.7;
        }
    }
    @-o-keyframes icon_animate {
        /* Opera */
        0% {
            transform: scale(1);
            -ms-transform: scale(1);
            -webkit-transform: scale(1);
            -o-transform: scale(1);
            -moz-transform: scale(1);
            opacity: 0.7;
        }
        50% {
            transform: scale(1.1);
            -ms-transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -o-transform: scale(1.1);
            -moz-transform: scale(1.1);
            opacity: 1;
        }
        100% {
            transform: scale(1);
            -ms-transform: scale(1);
            -webkit-transform: scale(1);
            -o-transform: scale(1);
            -moz-transform: scale(1);
            opacity: 0.7;
        }
    }
    /* 解决地图标记全屏后不显示问题 */
    /deep/ .pos-icon {
        background-size: 100% 100%;
        background-image: url('./img/posicon.png');
        animation: icon_animate 1s infinite;
        -moz-animation: icon_animate 1s infinite;
        -webkit-animation: icon_animate 1s infinite;
        -o-animation: icon_animate 1s infinite;
    }
    /deep/ .openseadragon-canvas a {
        cursor: pointer;
    }

    .bottom-pic-list{
        position: fixed;
        width: 100%;
        height: 120px;
        bottom: 0;
        left: 0;
        background: rgba(0,0,0,.2);
        @media(min-height: 900px){
            height: 160px;
        }
        @media(min-height: 1000px){
            height: 200px;
        }
        @media(min-height: 1100px){
            height: 240px;
        }
        .bottom-pic-list-pos{
            position: absolute;
            display: flex;
            flex-wrap: nowrap;
            top: 10px;
            left: 0;
            bottom: 10px;
            z-index: 2;
            .item-cell{
                display: flex;
                width: auto;
                height: 100%;
                position: relative;
                flex-shrink: 0;
                &:hover{
                    .hover-text{
                        display: block;
                    }
                }
                img{
                    // width: auto;
                    width: 205px;
                    height: 100%;
                }
                .hover-text{
                    display: none;
                    position: absolute;
                    background: rgba(0,0,0,.6);
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    font-size: 12px;
                    line-height: 1.5;
                    padding: 10px 0;
                    p{
                        margin: 0 auto;
                        width: 90%;
                        color: #fff;
                    }
                    a{
                        position: absolute;
                        bottom: 10px;
                        right: 10px;
                        color: #fff;
                        font-size: 22px;
                    }
                }
            }
        }
        &:before{
            content: "";
            position: absolute;
            width: 100%;
            height: 28px;
            left: 0;
            top: 0;
            background-size: auto 80%;
            background-repeat: repeat-x;
            background-image: url("./img/btm.png");
        }
        &:after{
            content: "";
            position: absolute;
            width: 100%;
            height: 28px;
            left: 0;
            bottom: -10px;
            background-size: auto 80%;
            background-repeat: repeat-x;
            background-image: url("./img/btm.png");
        }
    }
    .section-2 {
        background: #003b56;
        .tab-box {
            width: 100%;
            padding-top: 80px;
            .tabs {
                width: 95%;
                max-width: 1306px;
                height: auto;
                display: flex;
                margin: 0 auto;
                justify-content: center;
                align-items: center;
                position: relative;
                &:before {
                    position: absolute;
                    content: '';
                    width: 1406px;
                    height: 54px;
                    background-size: 100% 100%;
                    background-image: url("./img/tabbg.png");
                    top: 50%;
                    margin-top: -27px;
                    left: 50%;
                    margin-left: -703px;
                }
                .tab {
                    position: relative;
                    z-index: 2;
                    text-align: center;
                    width: 150px;
                    line-height: 2;
                    cursor: pointer;
                    img {
                        display: block;
                        max-height: 50px;
                        width: auto;
                        margin: 0 auto;
                        transition: transform .4s;
                    }
                    &.cur,&:hover{
                        font-weight: bold;
                        img{
                            transform: scale(1.15);
                        }
                    }
                }
            }
        }
        .tab-content3{
            width: 90%;
            max-width: 1300px;
            margin: 0 auto;
            padding: 20px 100px;
            position: relative;
            .map-box{
                height: 400px;
                width: 80%;
                margin: 0 auto;
                img{
                    max-height: 400px;
                    width: auto;
                    display: block;
                    margin: 0 auto;
                }
                /deep/ .pos-icon {
                    background-size: 100% 100%;
                    background-image: url('./img/posicon.png');
                    animation: icon_animate 1s infinite;
                    -moz-animation: icon_animate 1s infinite;
                    -webkit-animation: icon_animate 1s infinite;
                    -o-animation: icon_animate 1s infinite;
                }
            }
        }
        .tab-content2{
            width: 90%;
            max-width: 1300px;
            margin: 0 auto;
            padding: 50px 100px;
            position: relative;
            .prev-tab2{
                position: absolute;
                top: 45%;
                left: 0;
                color: #fff;
            }
            .next-tab2{
                position: absolute;
                top: 45%;
                right: 0;
                color: #fff;
            }
            .swipe-box{
                position: relative;
                width: 80%;
                margin: 0 auto;
                .des{
                    display: block;
                    text-align: center;
                    line-height: 2;
                    color: #fff;
                    font-weight: bold;
                }
            }
            /deep/ .basic-item{
                display: -webkit-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                -webkit-box-pack: center;
                -ms-flex-pack: center;
                -webkit-justify-content: center;
                justify-content: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                -webkit-align-items: center;
                align-items: center;
                transition: 300ms;
                transform: translate(0,0) scale(0.8);
                /deep/ img {
                    width: 254px!important;
                    height: 314px!important;
                }
            }
            /deep/.swiper-slide-prev,/deep/.swiper-slide-next{
                transform: translate(0,-10px) scale(0.8);
                z-index: 2;
            }
            /deep/ .swiper-slide-active,/deep/.swiper-slide-duplicate-active{
                transform: translate(0,0) scale(1);
                z-index: 3;
            }
        }
        .tab-content1{
            width: 90%;
            max-width: 1300px;
            margin: 0 auto;
            padding: 0 100px;
            position: relative;
            .swipe-box{
                padding: 4px 0;
                position: relative;
                /deep/img{
                    max-width: 100%;
                    max-height: 100%;
                }
                &:before{
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 4px;
                    background-size: auto 100%;
                    background-repeat: repeat-x;
                    background-image: url("./img/line.jpg");
                    top: 50px;
                    left: 0;
                }
                &:after{
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 4px;
                    background-size: auto 100%;
                    background-repeat: repeat-x;
                    background-image: url("./img/line.jpg");
                    bottom: 50px;
                    left: 0;
                }
                // .basic-item {
                //     img {
                //         width: 254px;
                //         height: 314px;
                //     }
                // }
            }
            .prev-tab1{
                position: absolute;
                top: 45%;
                left: 0;
                color: #fff;
            }
            .next-tab1{
                position: absolute;
                top: 45%;
                right: 0;
                color: #fff;
            }
            .swipe-box{
                &:hover{
                    /deep/ .swiper-slide-active,/deep/.swiper-slide-duplicate-active{
                        .info,.content{
                            display: none;
                        }
                    }
                }
            }
            /deep/ .basic-item{
                position: relative;
                padding: 50px 0;
                &:hover{
                    .info,.content{
                        display: block !important;
                    }
                }
                img {
                    width: 254px;
                    height: 314px;
                }
                .info{
                    display: none;
                    position: absolute;
                    height: 50px;
                    left: 0;
                    width: 100%;
                    top: 0;
                    padding: 8px 20px;
                    box-sizing: border-box;
                    .name{
                        font-size: 15px;
                        line-height: 20px;
                        color: #fff;
                    }
                    .des{
                        color: #888;
                        font-size: 13px;
                        line-height: 16px;
                    }
                }
                .content{
                    display: none;
                    position: absolute;
                    height: 50px;
                    left: 0;
                    width: 100%;
                    bottom: 0;
                    padding: 8px 20px;
                    font-size: 13px;
                    line-height: 16px;
                    color: #fff;
                    box-sizing: border-box;
                    overflow: hidden;
                }
            }
            /deep/ .swiper-slide-active,/deep/.swiper-slide-duplicate-active{
                .info,.content{
                    display: block;
                    border-left: 2px solid #f0be73;
                }
            }
        }
    }
</style>
